import * as React from "react";
import { ZUid } from "src/types/zUid";
import { Empty, Form, Spin } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { classNames } from "src/common/classNames";
import imgSwitch from "src/pages/ManagementPage/Obj2Tab/forms/RestrictionsTable/switch.svg";
import { ZBom3MatrixSettings, ZBom3Settings } from "../../ZBom3Settings";
import styles from "./Bom3MatrixEdit.module.less";

type PropsBom3MatrixEdit = {
  loading: boolean;
  label: React.ReactNode;
  name: keyof ZBom3Settings;
};

export const Bom3MatrixEdit: React.FC<PropsBom3MatrixEdit> = ({
  loading,
  label,
  name,
}) => (
  <Spin spinning={loading}>
    <Form.Item name={name} label={label}>
      <Inner />
    </Form.Item>
  </Spin>
);

type PropsInner = {
  value?: ZBom3MatrixSettings;
  onChange?: (newValue: ZBom3MatrixSettings) => void;
};
const mkKey = (rowId: ZUid, columnId: ZUid) => `${rowId}:${columnId}`;

const Inner: React.FC<PropsInner> = ({ value, onChange }) => {
  const [transpon, setTranspon] = React.useState(false);

  if (!value) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }
  const dict: Record<string, boolean> = {};
  value.cells.forEach(({ rowId, columnId, enabled }) => {
    dict[mkKey(rowId, columnId)] = enabled;
  });
  const onCell = (key: string) => {
    const newDict = { ...dict };
    newDict[key] = !newDict[key];
    const newValue: ZBom3MatrixSettings = { ...value, cells: [] };
    newValue.rows.forEach((row) => {
      newValue.columns.forEach((col) => {
        newValue.cells.push({
          rowId: row.id,
          columnId: col.id,
          enabled: !!newDict[mkKey(row.id, col.id)],
        });
      });
    });
    onChange?.(newValue);
  };
  const [visibleRows, visibleColumns, visibleKey] = !transpon
    ? [value.rows, value.columns, mkKey]
    : [value.columns, value.rows, (r: ZUid, c: ZUid) => mkKey(c, r)];
  const toggleTranspon = () => setTranspon((prev) => !prev);
  return (
    <div className={styles.box}>
      <table className={styles.table}>
        <tr>
          <td>
            <button
              className={styles.button}
              type="button"
              title="Поменять местами строки и столбцы"
              onClick={toggleTranspon}
            >
              <img src={imgSwitch} alt="" />
            </button>
          </td>
          {visibleColumns.map(({ id, name }) => (
            <td key={id}>{name}</td>
          ))}
        </tr>
        {visibleRows.map(({ id: visRowId, name: visRowName }) => (
          <tr key={visRowId}>
            <td>{visRowName}</td>
            {visibleColumns.map(({ id: visColumnId }) => (
              <td key={visColumnId}>
                <button
                  type="button"
                  className={classNames([styles.button, styles.red])}
                  onClick={() => onCell(visibleKey(visRowId, visColumnId))}
                >
                  {dict[visibleKey(visRowId, visColumnId)] && <CheckOutlined />}
                </button>
              </td>
            ))}
          </tr>
        ))}
      </table>
    </div>
  );
};
